import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/site/Seo";
import { PageHero, ClosingCta, RequestButton } from "../components/site/Blocks";
import { Reveal } from "../components/site/Primitives";
import { SERVICES } from "../data/services";

export default function ServicesIndex() {
  return (
    <>
      <Seo title="Professional Services" description="Independent professional services across auditing, consulting, advisory, tax and law, available through the Trusted Leap network of vetted experts." path="/services" />
      <PageHero eyebrow="Services" title="Specialist expertise. Across five disciplines." intro="The Trusted Leap network brings together independent practitioners across five professional disciplines. Each request is matched according to scope, industry context and jurisdiction.">
        <RequestButton testId="services-hero-request-button" />
      </PageHero>
      <section className="bg-white py-24">
        <div className="container-x divide-y divide-slate-200 border-y border-slate-200">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug}>
              <Link to={`/services/${s.slug}`} className="group grid items-center gap-8 py-12 md:grid-cols-12" data-testid={`services-row-${s.slug}`}>
                <span className="font-display text-sm font-semibold text-[#2563EB] md:col-span-1">0{i + 1}</span>
                <div className="md:col-span-4">
                  <h2 className="flex items-center gap-4 font-display text-3xl font-semibold tracking-tight text-[#0B1220] transition-colors group-hover:text-[#2563EB]">
                    <s.icon className="h-7 w-7 text-[#2563EB]" strokeWidth={1.4} /> {s.name}
                  </h2>
                </div>
                <p className="text-[15px] leading-relaxed text-slate-600 md:col-span-5">{s.summary}</p>
                <span className="flex justify-start md:col-span-2 md:justify-end">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-slate-300 transition-colors group-hover:border-[#2563EB] group-hover:bg-[#2563EB] group-hover:text-white">
                    <ArrowUpRight className="h-5 w-5" />
                  </span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <ClosingCta />
    </>
  );
}
